<template>
  <div id="terms-acknowledgement" class="component">
    <div v-for="(term, index) in terms" :key="index">
      <TermsLink
        v-model="term.value"
        :name="term.name"
        :href="term.link"
        :visited="term.visited"
        @click="hyperLinkVisited(index);"
      />
    </div>
    <!-- additional declaration for commercial product -->
    <label v-if="isCommercialEngine" class="text-normal">
      <input
        type="checkbox"
        :value="commercialTerms2.value"
        @change="commercialTerms2.value = !commercialTerms2.value;"
      />
      {{ commercialTerms2.name }}
    </label>
    <label v-if="isCommercialEngine && isConsultant" class="text-normal">
      <input
        type="checkbox"
        :value="commercialTerms3.value"
        @change="commercialTerms3.value = !commercialTerms3.value;"
      />
      {{ commercialTerms3.name }}
    </label>
    <label v-if="isCommercialEngine && isPurchasingAgent" class="text-normal">
      <input
        type="checkbox"
        :value="commercialTerms4.value"
        @change="commercialTerms4.value = !commercialTerms4.value;"
      />
      {{ commercialTerms4.name }}
    </label>
    <label v-if="isCommercialEngine && isInternalVendor" class="text-normal">
      <input
        type="checkbox"
        :value="commercialTerms5.value"
        @change="commercialTerms5.value = !commercialTerms5.value;"
      />
      {{ commercialTerms5.name }}
    </label>
    <label v-if="isCommercialEngine && isInternalVendor" class="text-normal">
      <input
        type="checkbox"
        :value="commercialTerms6.value"
        @change="commercialTerms6.value = !commercialTerms6.value;"
      />
      {{ commercialTerms6.name }}
    </label>
    <!-- register company button -->
    <div class="action-btns">
      <button class="btn btn-sm btn-primary" @click="registerCompany">Submit Application Request</button>
      <span v-if="showError1" class="text-danger"
        >Please read and accept all terms and conditions to proceed further.</span
      >
    </div>
  </div>
</template>
<script>
import TermsLink from "@/mycfm/components/new-company/TermsLink";
import { mapState } from "vuex";

export default {
  components: {
    TermsLink
  },
  data() {
    return {
      commercialTerms: {
        name: "Commercial General Terms & Conditions",
        value: false,
        visited: false,
        link: "/access/terms-conditions/mygea/commercialTermsConditions.pdf"
      },
      commercialTerms2: {
        name:
          "I am authorized to sign on behalf of my company and bind my company to the terms and conditions of the agreement.",
        value: false
      },
      commercialTerms3: {
        name:
          "I acknowledge the ability to retrieve a confirmation letter from airline/owner documenting use of our consulting services before agreement is finalized.",
        value: false
      },
      commercialTerms4: {
        name:
          "I acknowledge the ability to retrieve a confirmation letter from airline/owner documenting use of our services before agreement is finalized.",
        value: false
      },
      commercialTerms5: {
        name:
          "I acknowledge the ability to supply a sourcing agreement between CFM/SAE/GE and us before agreement is finalized.",
        value: false
      },
      commercialTerms6: {
        name: "I acknowledge that we will not conduct third-party activity for the selected engine models.",
        value: false
      },
      bgaTerms: {
        name: "BGA General Terms & Conditions",
        value: false,
        visited: false,
        link: "/access/terms-conditions/mygea/bgaTermsComditions.pdf"
      },
      airframeTerms: {
        name: "Airframe Systems Proprietary Information Agreement",
        value: false,
        visited: false,
        link: "/access/terms-conditions/mycfm/Proprietary_Information_Agreement.pdf"
      },
      cfmCommercialGeneralTerms: {
        name: "CFM Commercial General Terms & Conditions",
        value: false,
        visited: false,
        link: "/access/terms-conditions/mycfm/Electronic_Acceptance_CFM.pdf"
      },
      terms: [
        {
          name: "Privacy Policy",
          value: false,
          visited: false,
          link: "/custom-login/cfm-privacy-policy.html"
        }
      ],
      showError: false
    };
  },
  computed: {
    ...mapState({
    isCommercialEngine: state => state.product.productTypes.commercial !== null,
    isConsultant: state =>
      state.product.productTypes.commercial !== null &&
      parseInt(state.product.productTypes.commercial.companyDetails.companyTypeId) == 13,
    isPurchasingAgent: state =>
      state.product.productTypes.commercial !== null &&
      parseInt(state.product.productTypes.commercial.companyDetails.companyTypeId) == 12,
    isInternalVendor: state =>
      state.product.productTypes.commercial !== null &&
      parseInt(state.product.productTypes.commercial.companyDetails.companyTypeId) == 11
  }),
  showError1(){
    return this.showError == true ? (this.termsFailed() == true ? true : false) : this.showError
  }
  },
  created() {
    // add commercial terms to terms array
    if (this.$store.getters["product/showCommercialTerms"]) {
      this.terms.push(this.commercialTerms);
    } else if (this.$store.getters["product/showCommercialTermsForBGA"]) {
      this.terms.push(this.commercialTerms);
    }

    // add airframe terms to terms array
    if (this.$store.getters["product/showAirframeTerms"]) {
      this.terms.push(this.airframeTerms);
    }

    //  add bga terms to terms array
    if (this.$store.getters["product/showBGATerms"]) {
      this.terms.push(this.bgaTerms);
    }

    // adding CFM Commercial General Terms & Conditions based on engine model
    if (this.$store.getters["product/showCFMCommercialGeneralTerms"]) {
      this.terms.push(this.cfmCommercialGeneralTerms);
    }
  },
  methods: {
    termsFailed() {
      let termsFail = this.terms.some(terms => {
        return terms.value == false;
      });
      if (this.isCommercialEngine && this.isConsultant) {
        return termsFail || (this.isCommercialEngine && (!this.commercialTerms2.value || !this.commercialTerms3.value));
      } else if (this.isCommercialEngine && this.isPurchasingAgent) {
        return termsFail || (this.isCommercialEngine && (!this.commercialTerms2.value || !this.commercialTerms4.value));
      } else if (this.isCommercialEngine && this.isInternalVendor) {
        return (
          termsFail ||
          (this.isCommercialEngine &&
            (!this.commercialTerms2.value || !this.commercialTerms5.value || !this.commercialTerms6.value))
        );
      } else {
        return termsFail || (this.isCommercialEngine && !this.commercialTerms2.value);
      }
    },
    hyperLinkVisited(index) {
      this.terms[index].visited = true;
    },
    registerCompany() {
      this.showError = true;
      if(!this.termsFailed()){
        this.$emit("complete");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.text-normal {
  display: table;
  font-size: 15px;
  margin-bottom: 10px;
  input {
    margin-right: 7px;
  }
}
</style>
